"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var Text_1 = __importDefault(require("../../Text"));
var styles = {
    container: react_1.css({
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
    }),
};
var TextLabel = function (props) {
    var _a = props.label, label = _a === void 0 ? 'label' : _a, _b = props.labelColor, labelColor = _b === void 0 ? style_1.DesignSystemColor.Gray.DEFAULT : _b, children = props.children;
    return (react_1.jsx("label", { css: styles.container },
        label ? (react_1.jsx(Text_1.default.Body, { color: labelColor }, label)) : null,
        children));
};
exports.default = TextLabel;
